/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iletisim_S6_Label_Trade_NameInputs */

const tr_iletisim_s6_label_trade_name = /** @type {(inputs: Iletisim_S6_Label_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticaret Unvanı`)
};

const en_iletisim_s6_label_trade_name = /** @type {(inputs: Iletisim_S6_Label_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trade name`)
};

const de_iletisim_s6_label_trade_name = /** @type {(inputs: Iletisim_S6_Label_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Handelsname`)
};

const ru_iletisim_s6_label_trade_name = /** @type {(inputs: Iletisim_S6_Label_Trade_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Торговое наименование`)
};

/**
* | output |
* | --- |
* | "Trade name" |
*
* @param {Iletisim_S6_Label_Trade_NameInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iletisim_s6_label_trade_name = /** @type {((inputs?: Iletisim_S6_Label_Trade_NameInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iletisim_S6_Label_Trade_NameInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iletisim_s6_label_trade_name(inputs)
	if (locale === "de") return de_iletisim_s6_label_trade_name(inputs)
	if (locale === "ru") return ru_iletisim_s6_label_trade_name(inputs)
	return tr_iletisim_s6_label_trade_name(inputs)
});